/**
 * Session and CSRF transport policy.
 *
 * The session token is only ever carried in an HttpOnly cookie. It is never
 * written to `localStorage`, `sessionStorage`, a URL, or a response body — a
 * token readable by JavaScript is a token an XSS bug can exfiltrate.
 */
export const SESSION_COOKIE_NAME = 'napaicp_session'

/**
 * Double-submit CSRF token. Deliberately NOT HttpOnly: the frontend has to read
 * it to echo it back in the request header. It grants no authority on its own.
 */
export const CSRF_COOKIE_NAME = 'napaicp_csrf'
export const CSRF_HEADER_NAME = 'x-csrf-token'

export const SESSION_TOKEN_BYTES = 32
export const CSRF_TOKEN_BYTES = 32

/** Sliding window: a session dies this long after its last request. */
export const SESSION_IDLE_TTL_SECONDS = 60 * 60 * 12

/** Hard ceiling: a session dies this long after creation, however active. */
export const SESSION_ABSOLUTE_TTL_SECONDS = 60 * 60 * 24 * 7

/** Requests closer together than this do not bother rewriting `last_seen_at`. */
export const SESSION_TOUCH_INTERVAL_SECONDS = 60

/** HTTP methods that never mutate state, and so skip CSRF enforcement. */
export const SAFE_HTTP_METHODS: readonly string[] = ['GET', 'HEAD', 'OPTIONS']
